/* Zolo — Quiz: single-select flow with a most-voted product recommendation. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.zquizInit) return;
    root.dataset.zquizInit = '1';

    var screens = Array.prototype.slice.call(root.querySelectorAll('[data-zquiz-screen]'));
    var order = screens.map(function (s) { return s.getAttribute('data-zquiz-screen'); });
    var questions = screens.filter(function (s) { return s.hasAttribute('data-zquiz-question'); });
    var products = {};
    var src = root.querySelector('[data-zquiz-products]');
    try { products = JSON.parse(src ? src.textContent : '{}') || {}; } catch (e) { products = {}; }
    var current = 'intro';

    var card = root.querySelector('.zquiz-card');
    // keep the card at the intro's rendered height so later, shorter screens
    // don't reflow the page; re-measured on resize while the intro is showing
    function lockHeight() {
      if (!card || current !== 'intro') return;
      card.style.minHeight = '';
      card.style.minHeight = Math.ceil(card.getBoundingClientRect().height) + 'px';
    }
    function show(name, scroll) {
      screens.forEach(function (s) { s.hidden = s.getAttribute('data-zquiz-screen') !== name; });
      current = name;
      if (scroll === false) return;
      // only bring the card back into view when its top has scrolled under the header
      var top = root.getBoundingClientRect().top;
      if (top < 80) window.scrollTo({ top: Math.max(0, top + window.pageYOffset - 88), behavior: 'smooth' });
    }
    function step(delta) {
      var i = order.indexOf(current) + delta;
      if (i >= 0 && i < order.length) show(order[i]);
    }
    function chosen() {
      return questions.map(function (q) {
        var b = q.querySelector('[data-zquiz-option][aria-pressed="true"]');
        return b ? (b.getAttribute('data-zquiz-product') || '') : '';
      });
    }
    function winner() {
      var votes = {}, seen = [];
      chosen().forEach(function (h) {
        if (!h || !products[h]) return;
        if (!votes[h]) { votes[h] = 0; seen.push(h); }
        votes[h] += 1;
      });
      var best = null;
      // ties go to the later answer: flavour is a more specific signal than usage
      seen.forEach(function (h) { if (best === null || votes[h] >= votes[best]) best = h; });
      if (best) return products[best];
      return products.__fallback || null;
    }
    function renderResult() {
      var card = root.querySelector('[data-zquiz-result]');
      var empty = root.querySelector('[data-zquiz-result-empty]');
      var win = winner();
      if (!card) return;
      if (win) {
        var img = card.querySelector('[data-zquiz-result-image]');
        if (img) {
          img.hidden = !win.image;
          if (win.image) { img.src = win.image; img.alt = win.title || ''; }
        }
        var t = card.querySelector('[data-zquiz-result-title]'); if (t) t.textContent = win.title || '';
        var p = card.querySelector('[data-zquiz-result-price]'); if (p) p.textContent = win.price || '';
        var a = card.querySelector('[data-zquiz-result-link]'); if (a) a.href = win.url || '#';
      }
      card.hidden = !win;
      if (empty) empty.hidden = !!win;
    }
    function reset() {
      root.querySelectorAll('[data-zquiz-option]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      root.querySelectorAll('[data-zquiz-next]').forEach(function (b) { b.disabled = true; });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-zquiz-start],[data-zquiz-option],[data-zquiz-next],[data-zquiz-back],[data-zquiz-finish],[data-zquiz-retake]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-zquiz-option')) {
        var q = t.closest('[data-zquiz-question]');
        if (!q) return;
        q.querySelectorAll('[data-zquiz-option]').forEach(function (b) { b.setAttribute('aria-pressed', b === t ? 'true' : 'false'); });
        var n = q.querySelector('[data-zquiz-next]');
        if (n) n.disabled = false;
      } else if (t.hasAttribute('data-zquiz-start')) {
        step(1);
      } else if (t.hasAttribute('data-zquiz-next')) {
        if (!t.disabled) step(1);
      } else if (t.hasAttribute('data-zquiz-back')) {
        step(-1);
      } else if (t.hasAttribute('data-zquiz-finish')) {
        renderResult();
        show('result');
      } else if (t.hasAttribute('data-zquiz-retake')) {
        reset();
        show('intro');
        lockHeight();
      }
    });

    show('intro', false);
    lockHeight();
    window.addEventListener('load', lockHeight);
    var resizeTimer;
    window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(lockHeight, 150); });
    // theme editor: reveal the screen that holds a selected block
    root.__zquizReveal = function (el) {
      var s = el && el.closest ? el.closest('[data-zquiz-screen]') : null;
      if (s) show(s.getAttribute('data-zquiz-screen'), false);
    };
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-zquiz]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest ? e.target.closest('[data-zquiz]') : null;
    if (root && root.__zquizReveal) root.__zquizReveal(e.target);
  });
})();
